// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  background-color: var(--color-surface);
}

ion-header::after {
  background-image: none;
}
ion-header {
  box-shadow: none;
}
ion-header ion-toolbar {
  font-family: "DM Sans", sans-serif;
  padding: 0 20px;
}
ion-header ion-toolbar.titleBar {
  margin: 10px 0;
  padding: var(--ion-safe-area-top, 0) 0 0 0;
}
ion-header ion-toolbar.titleBar .back-button {
  --padding-start: 5px;
  --padding-end: 5px;
}
ion-header ion-toolbar.titleBar .back-button ion-icon {
  font-size: 32px !important;
}
ion-header ion-toolbar.titleBar .toolbar-title h3 {
  margin: 0;
  font-size: var(--font-size-xl);
  font-weight: bold;
  color: var(--ion-color-primary);
}
ion-header ion-toolbar.titleBar .toolbar-title p {
  margin: 0;
  font-size: var(--font-size-sm);
  color: #92929D;
}
ion-header ion-toolbar.stepsBar {
  --min-height: 0;
}
ion-header ion-toolbar.stepsBar .toolbar-content {
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  margin: 10px 0 20px;
}
ion-header ion-toolbar.stepsBar .toolbar-content .step {
  flex-grow: 1;
  min-width: 50px;
  height: 8px;
  border-radius: var(--radius-sm);
  margin-right: var(--space-xs);
  background-color: var(--ion-color-tertiary);
}
ion-header ion-toolbar.stepsBar .toolbar-content .step:last-child {
  margin-right: 0;
}
ion-header ion-toolbar.stepsBar .toolbar-content .step.current {
  background-color: var(--ion-color-primary);
}
ion-header ion-toolbar.searchbar-toolbar ion-searchbar {
  --border-radius: var(--radius-md);
  --box-shadow: 0 0 0 1px #F1F1F5;
  --icon-color: #B5B5BE;
  --placeholder-color: #B5B5BE;
  --placeholder-opacity: 1;
  margin-top: 0;
  margin-bottom: 0;
  padding-inline-start: 1px;
  padding-inline-end: 1px;
  font-family: "DM Sans", sans-serif;
}
ion-header ion-toolbar.searchbar-toolbar ion-searchbar.searchbar-has-focus {
  --icon-color: var(--ion-color-primary);
  --color: var(--ion-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/generic-header/generic-header.component.scss"],"names":[],"mappings":"AACA;EACI,sCAAA;AAAJ;;AAGI;EACI,sBAAA;AAAR;AAFA;EAII,gBAAA;AACJ;AACI;EACI,kCAAA;EAEA,eAAA;AAAR;AAEQ;EACI,cAAA;EACA,0CAAA;AAAZ;AAEY;EACI,oBAAA;EACA,kBAAA;AAAhB;AAEgB;EACI,0BAAA;AAApB;AAKgB;EACI,SAAA;EACA,8BAAA;EACA,iBAAA;EACA,+BAAA;AAHpB;AAMgB;EACI,SAAA;EACA,8BAAA;EACA,cAAA;AAJpB;AASQ;EACI,eAAA;AAPZ;AASY;EACI,aAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;AAPhB;AASgB;EACI,YAAA;EACA,eAAA;EACA,WAAA;EACA,+BAAA;EACA,6BAAA;EAEA,2CAAA;AARpB;AAUoB;EACI,eAAA;AARxB;AAWoB;EACI,0CAAA;AATxB;AAgBY;EACI,iCAAA;EACA,+BAAA;EACA,qBAAA;EACA,4BAAA;EACA,wBAAA;EAEA,aAAA;EACA,gBAAA;EAEA,yBAAA;EACA,uBAAA;EAEA,kCAAA;AAjBhB;AAmBgB;EACI,sCAAA;EACA,iCAAA;AAjBpB","sourcesContent":["\r\n:host {\r\n    background-color: var(--color-surface);\r\n}\r\nion-header {\r\n    &::after {\r\n        background-image: none;\r\n    }\r\n    box-shadow: none;\r\n\r\n    ion-toolbar {\r\n        font-family: \"DM Sans\", sans-serif;\r\n\r\n        padding: 0 20px;\r\n\r\n        &.titleBar {\r\n            margin: 10px 0;\r\n            padding: var(--ion-safe-area-top, 0) 0 0 0;\r\n\r\n            .back-button {\r\n                --padding-start: 5px;\r\n                --padding-end: 5px;\r\n\r\n                ion-icon {\r\n                    font-size: 32px !important;\r\n                }\r\n            }\r\n\r\n            .toolbar-title {\r\n                h3 {\r\n                    margin: 0;\r\n                    font-size: var(--font-size-xl);\r\n                    font-weight: bold;\r\n                    color: var(--ion-color-primary);\r\n                }\r\n\r\n                p {\r\n                    margin: 0;\r\n                    font-size: var(--font-size-sm);\r\n                    color: #92929D;\r\n                }\r\n            }\r\n        }\r\n\r\n        &.stepsBar {\r\n            --min-height: 0;\r\n\r\n            .toolbar-content {\r\n                display: flex;\r\n                flex-flow: row nowrap;\r\n                width: 100%;\r\n                margin: 10px 0 20px;\r\n\r\n                .step {\r\n                    flex-grow: 1;\r\n                    min-width: 50px;\r\n                    height: 8px;\r\n                    border-radius: var(--radius-sm);\r\n                    margin-right: var(--space-xs);\r\n\r\n                    background-color: var(--ion-color-tertiary);\r\n\r\n                    &:last-child {\r\n                        margin-right: 0;\r\n                    }\r\n\r\n                    &.current {\r\n                        background-color: var(--ion-color-primary);\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        &.searchbar-toolbar {\r\n            ion-searchbar {\r\n                --border-radius: var(--radius-md);\r\n                --box-shadow: 0 0 0 1px #F1F1F5;\r\n                --icon-color: #B5B5BE;\r\n                --placeholder-color: #B5B5BE;\r\n                --placeholder-opacity: 1;\r\n\r\n                margin-top: 0;\r\n                margin-bottom: 0;\r\n                \r\n                padding-inline-start: 1px;\r\n                padding-inline-end: 1px;\r\n\r\n                font-family: \"DM Sans\", sans-serif;\r\n\r\n                &.searchbar-has-focus {\r\n                    --icon-color: var(--ion-color-primary);\r\n                    --color: var(--ion-color-primary);\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
